<div class="apg-panel" [appScrollIntoView]="true">
  <div class="title">Declaration</div>

  <p>Read this information carefully, and get in touch if there's anything you're not sure about.</p>

  <app-expander key="FullQuote.FinalDeclaration-FinancialCrime"></app-expander>

  <app-expander key="FullQuote.FinalDeclaration-AMRARights"></app-expander>

  <app-site-content class="confirm" [showTitle]="false" key="FullQuote.FinalDeclaration"></app-site-content>

  <div class="summary__buttons" buttons>
     <ion-button (click)="back.emit()">
      <ion-icon name="chevron-back-outline"></ion-icon>
      Back
    </ion-button>

    <ion-button (click)="continue.emit()">
      Continue
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>

